module.exports = __webpack_public_path__ + "img/banner-loading.dad62a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/front/assets/images/project/loader/banner-loading.jpg
// module id = fJsO
// module chunks = 9